import { useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import TermsOfUseHealcore from "../termsOfUse/TermsOfUseHealcore";
import TermsOfUseLucasAI from "../termsOfUse/TermsOfUseLucasAI";
import TermsOfUseLucasAIEs from "../termsOfUse/TermsOfUseLucasAIEs";
import TermsOfUseRpg from "../termsOfUse/TermsOfUseRpg";

function TermsOfUseText() {
  const { brand, auth } = useAuth();
  const [lang, setLang] = useState(auth.user.language);

  const getText = () => {
    if (brand === "healcore") {
      return <TermsOfUseHealcore />;
    }

    if (brand === "rpg") {
      return <TermsOfUseRpg />;
    }

    if (lang === "es") {
      return <TermsOfUseLucasAIEs />;
    } else {
      return <TermsOfUseLucasAI />;
    }
  };

  return (
    <>
      {!brand && (
        <div>
          {lang === "es" ? (
            <button className={`gray`} onClick={() => setLang("en")}>
              English
            </button>
          ) : (
            <button className={`gray`} onClick={() => setLang("es")}>
              Español
            </button>
          )}
        </div>
      )}

      {getText()}
    </>
  );
}

export default TermsOfUseText;
